export function degToRad(deg: number) {
  return (Math.PI / 180) * deg
}

export function factorial(value: number) {
  let result = 1

  for (let i = 2; i <= value; i++) {
    result *= i
  }

  return result
}
